module.exports = __webpack_public_path__ + "static/media/styledmenu-arrow-down-white.13dd4bee.svg";